export default __webpack_public_path__ + "static/media/big-bang-theory.efb3a74f.png";